import React, { useEffect, useState } from "react";
import axios from "axios";

const API = "https://login.abhedasramam.org/myapp/api";

function EmagazineList() {
  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ id: "", month: "", year: "", url: "" });

  // ✅ FETCH DATA
  const fetchData = async () => {
    try {
      const res = await axios.get(`${API}/get_emagazine.php`);
      console.log("API RESPONSE:", res.data);

      // 🔥 handle both formats
      if (Array.isArray(res.data)) {
        setData(res.data);
      } else if (res.data.data) {
        setData(res.data.data);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ✅ EDIT START
  const startEdit = (item) => {
    setEditId(item.id);
    setForm({
      id: item.id,
      month: item.month,
      year: item.year,
      url: item.url,
    });
  };

  // ✅ CANCEL EDIT
  const cancelEdit = () => {
    setEditId(null);
    setForm({ id: "", month: "", year: "", url: "" });
  };

  // ✅ SAVE EDIT
  const saveEdit = async () => {
    try {
      await axios.post(`${API}/update_emagazine.php`, form);
      setEditId(null);
      fetchData();
    } catch (err) {
      console.error("Update error:", err);
    }
  };

  // ✅ DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this record?")) return;

    try {
      await axios.post(`${API}/delete_emagazine.php`, { id });
      fetchData();
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <h3>E-Magazine List</h3>

      <table className="table">
        <thead>
          <tr>
            <th>#</th>
            <th>Month</th>
            <th>Year</th>
            <th>URL</th>
            <th>Uploaded</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>

                {/* MONTH */}
                <td>
                  {editId === item.id ? (
                    <input
                      value={form.month}
                      onChange={(e) =>
                        setForm({ ...form, month: e.target.value })
                      }
                    />
                  ) : (
                    item.month
                  )}
                </td>

                {/* YEAR */}
                <td>
                  {editId === item.id ? (
                    <input
                      value={form.year}
                      onChange={(e) =>
                        setForm({ ...form, year: e.target.value })
                      }
                    />
                  ) : (
                    item.year
                  )}
                </td>

                {/* URL */}
                <td>
                  {editId === item.id ? (
                    <textarea className="form-control" 
                      value={form.url}
                      onChange={(e) =>
                        setForm({ ...form, url: e.target.value })
                      }
                    ></textarea>
                  ) : (
                    <a href={item.url} target="_blank" rel="noreferrer">
                      View
                    </a>
                  )}
                </td>

                <td>{item.uploaded_at}</td>

                {/* ACTION */}
                <td>
                  {editId === item.id ? (
                    <>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={saveEdit}
                      >
                        <i class="fa fa-floppy-o" aria-hidden="true"></i>
                      </button>{" "}
                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={cancelEdit}
                      >
                         <i class="fa fa-window-close" aria-hidden="true"></i>
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="btn btn-primary btn-sm" title="Edit" style={{border:'1px solid orange',color:'#004962ff',background:'white',cursor:'pointer'}}
                        onClick={() => startEdit(item)}
                      >
                         <i class="fa fa-pencil" aria-hidden="true" ></i>
                      </button>{" "}
                      <button title="Delete" style={{cursor:'pointer'}}
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(item.id)}
                      >
                       <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default EmagazineList;